import {
  Collapse as _Collapse,
  UncontrolledCollapse as _UncontrolledCollapse,
  CollapseProps as _CollapseProps,
  UncontrolledCollapseProps as _UncontrolledCollapseProps
} from "reactstrap";

export const Collapse = _Collapse;
export const UncontrolledCollapse = _UncontrolledCollapse;

export type CollapseProps = _CollapseProps;
export type UncontrolledCollapseProps = _UncontrolledCollapseProps;
